'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Guide(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 64 : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? null : _ref$icon;

  return _react2.default.createElement(
    'div',
    { style: { width: size, height: size + 5 }, className: 'jsx-3383499909' + ' ' + 'holder'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-3383499909' + ' ' + 'icon'
      },
      icon
    ),
    _react2.default.createElement(
      'svg',
      {
        width: size,
        height: size + 5,
        viewBox: '0 0 46 50',
        version: '1.1',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        className: 'jsx-3383499909'
      },
      _react2.default.createElement(
        'defs',
        {
          className: 'jsx-3383499909'
        },
        _react2.default.createElement(
          'linearGradient',
          { x1: '100%', y1: '100%', x2: '0%', y2: '100%', className: 'jsx-3383499909'
          },
          _react2.default.createElement('stop', { stopColor: '#FFF', offset: '0%', className: 'jsx-3383499909'
          }),
          _react2.default.createElement('stop', { stopColor: '#FFF', stopOpacity: 0, offset: '100%', className: 'jsx-3383499909'
          })
        ),
        _react2.default.createElement(
          'linearGradient',
          { x1: '50%', y1: '0%', x2: '50%', y2: '100%', className: 'jsx-3383499909'
          },
          _react2.default.createElement('stop', { stopColor: '#FFF', offset: '0%', className: 'jsx-3383499909'
          }),
          _react2.default.createElement('stop', { stopColor: '#FFF', stopOpacity: 0, offset: '100%', className: 'jsx-3383499909'
          })
        ),
        _react2.default.createElement(
          'linearGradient',
          { x1: '50%', y1: '0%', x2: '50%', y2: '100%', className: 'jsx-3383499909'
          },
          _react2.default.createElement('stop', { stopColor: '#000', stopOpacity: 0, offset: '0%', className: 'jsx-3383499909'
          }),
          _react2.default.createElement('stop', { stopColor: '#000', offset: '100%', className: 'jsx-3383499909'
          })
        )
      ),
      _react2.default.createElement(
        'g',
        {
          transform: 'translate(-6.000000, -2.000000)',
          stroke: 'none',
          strokeWidth: 1,
          fill: 'none',
          fillRule: 'evenodd',
          className: 'jsx-3383499909'
        },
        _react2.default.createElement('rect', { fill: '#C2C6C7', x: 6, y: 6, width: 46, height: 46, rx: 8, className: 'jsx-3383499909'
        }),
        _react2.default.createElement(
          'mask',
          { id: 'c', fill: '#fff', className: 'jsx-3383499909'
          },
          _react2.default.createElement('rect', { x: 8, y: 7, width: 42, height: 42, rx: 6, className: 'jsx-3383499909'
          })
        ),
        _react2.default.createElement('rect', { fill: '#F2F2F2', x: 8, y: 7, width: 42, height: 42, rx: 6, className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M47.185 13a.797.797 0 0 1-.808-.784 1.446 1.446 0 0 0-.393-1.174 1.543 1.543 0 0 0-1.176-.473.797.797 0 0 1-.808-.784c0-.433.362-.784.808-.784a3.162 3.162 0 0 1 2.324.926c.606.612.918 1.442.861 2.289a.772.772 0 0 1-.236.554.821.821 0 0 1-.572.23z',
          fill: '#FFF',
          fillRule: 'nonzero',
          opacity: '0.800000012',
          mask: 'url(#c)',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M41.365 10.6h-13.73c-.35 0-.635-.358-.635-.8 0-.442.284-.8.635-.8h13.73c.35 0 .635.358.635.8 0 .442-.284.8-.635.8z',
          fill: 'url(#d)',
          fillRule: 'nonzero',
          opacity: '0.5',
          mask: 'url(#c)',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M46.8 27c-.442 0-.8-.318-.8-.71V15.71c0-.392.358-.71.8-.71.442 0 .8.318.8.71v10.58c0 .392-.358.71-.8.71z',
          fill: 'url(#e)',
          fillRule: 'nonzero',
          opacity: '0.5',
          mask: 'url(#c)',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('circle', {
          stroke: '#96A0A2',
          strokeWidth: 3,
          mask: 'url(#c)',
          cx: '21.5',
          cy: '26.5',
          r: '5.5',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M21 32v7.5c0 2.5 1 3.5 3.5 3.5H34c3 0 3 2 3 3v4.031',
          stroke: '#96A0A2',
          strokeWidth: 3,
          mask: 'url(#c)',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(13.000000, 2.000000)', className: 'jsx-3383499909'
          },
          _react2.default.createElement('path', {
            d: 'M9.5 25c2.5 0 5.69-1.26 9.304-2.959 1.504-.707 3.85-1.969 4.466-2.621C25.278 17.294 22.694 16 18 16s-9.723 1.295-11.73 3.42c-.652.69-.595 1.88-.37 2.621C6.36 23.56 7 25 9.5 25z',
            fill: 'url(#f)',
            opacity: '0.200000018',
            className: 'jsx-3383499909'
          }),
          _react2.default.createElement('path', {
            d: 'M8.5 25c2.5 0 4.5-3.5 6.51-8.22.836-1.964 1.99-5.468 1.99-7.28C17 3.595 13.194 0 8.5 0S0 3.597 0 9.5c0 1.917 1.18 5.22 2.105 7.28C4 21 6 25 8.5 25z',
            fill: '#00BD9C',
            className: 'jsx-3383499909'
          }),
          _react2.default.createElement('circle', { fill: '#FFF', cx: '8.5', cy: '9.5', r: '2.5', className: 'jsx-3383499909'
          })
        )
      )
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '3383499909'
      },
      ['.green.jsx-3383499909{fill:#00b083;}', '.purple.jsx-3383499909{fill:#7878cb;}', '.gray.jsx-3383499909{fill:#767c7c;}', '.holder.jsx-3383499909{position:relative;display:inline-block;}', '.icon.jsx-3383499909{position:absolute;bottom:-10%;right:-5%;z-index:2;}']
    )
  );
}

Guide.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node
};

exports.default = Guide;